import { Button, Tabs } from "antd";
import AuthorisedContainer from "components/AuthorisedContainer";
import { PermissionSetMap } from "constants/RBACConstants";
import { useFeatureFlag } from "contexts/FeatureFlagContext";
import _ from "lodash";
import React, { useCallback, useRef } from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import ModalUtil from "utils/modalUtil";

import { IntegrationTicketingListingTable } from "../GenericIntegrationTicketSystemListing";
import { GenericIntegrationTicketDefaultValues } from "../genericIntegrationTicketConstants";
import GithubIssuesMappingForm from "./GithubIssuesMappingForm";
import RepositoryListing from "./RepositoryListing";

type GitHubIssuesListingProps = {
  onUpdateConfigComponent?: (param: boolean) => {};
  onAddConfigMapping?: () => {};
  name?: string;
  // TODO: define a proper type for repoListingData
  listingData?: any;
};

const getColumns = (columns: any[]) => {
  // GitHub Issues does not have projectKey and issueType
  return _.map(
    columns.filter((column) => column.dataIndex !== "issueType"),
    (column) =>
      column.dataIndex === "projectKey" ? { ...column, title: "Repo" } : column,
  );
};

type TableRefType = {
  refresh?: () => void;
  refreshFilters?: () => void;
};

function IssuesListing({
  onUpdateConfigComponent,
  listingData,
  name,
}: GitHubIssuesListingProps) {
  const tableRef = useRef<TableRefType>(null);
  const updateConfigListing = useCallback(() => {
    tableRef.current && tableRef.current.refresh!();
    tableRef.current && tableRef.current.refreshFilters!();
  }, [onUpdateConfigComponent]);

  const onAddConfigMapping = useCallback(
    (data: GenericIntegrationTicketDefaultValues) => {
      ModalUtil.show({
        content: (
          <GithubIssuesMappingForm
            onUpdateConfigComponent={updateConfigListing}
            name={name!}
            loginConfigId={listingData.id}
            config={data}
          />
        ),
      });
    },
    [listingData.id, name, onUpdateConfigComponent, updateConfigListing],
  );

  return (
    <>
      <div className="m-b-m m-l-auto" style={{ width: "max-content" }}>
        <AuthorisedContainer permission={PermissionSetMap.WRITE_TOOLS}>
          <Button
            size="small"
            type="primary"
            // TODO: Fix the type error
            // @ts-expect-error
            onClick={onAddConfigMapping}
          >
            Add Mapping
          </Button>
        </AuthorisedContainer>
      </div>
      <IntegrationTicketingListingTable
        configTableRef={tableRef}
        deleteAPI={ToolsIntegrationsAPI.deleteTicketSystemToolConfiguration}
        enabledAPI={
          ToolsIntegrationsAPI.updateTicketSystemToolConfigIntegration
        }
        getColumns={getColumns}
        loginConfig={listingData}
        name={name}
        onAddConfigMapping={onAddConfigMapping}
        updateConfigListing={updateConfigListing}
        showTicketTemplateAction={false}
        // @ts-expect-error
        apiFilterExtraParams={{ ticketSystem: "GITHUB_ISSUES" }}
      />
    </>
  );
}

function GitHubRepoAndIssuesListing({
  onUpdateConfigComponent,
  listingData,
  name,
}: GitHubIssuesListingProps) {
  const featureFlags = useFeatureFlag();
  const ListingWithTabs = (
    <>
      <Tabs>
        <Tabs.TabPane tab="Repositories" key="repositories">
          <RepositoryListing installation={listingData} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Issues" key="issues">
          <IssuesListing
            onUpdateConfigComponent={onUpdateConfigComponent}
            listingData={listingData}
            name={name}
          />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
  return featureFlags.GITHUB_ISSUES_CONFIG ? (
    ListingWithTabs
  ) : (
    <RepositoryListing installation={listingData} />
  );
}

export default GitHubRepoAndIssuesListing;
